import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import "./InquiryReply.css";


class InquiryReplyTitleBar extends Component {



    render() {

        return (
            <div className="title-1 text-align-left">
                <div className="row">
                    <div className="col-md-7 inquiry-tile-1">
                        &nbsp;{this.props.email} <span>  </span>
                        <FormattedMessage id="app.inquiry-reply.title"
                                          defaultMessage="Inquiry from"
                                          description=""/>
                        {/*&nbsp;{this.props.email}*/}
                    </div>
                    <div className="col-md-5 text-right inquiry-tile-1">
                        <FormattedMessage id="app.inquiry-reply.date"
                                          defaultMessage="Date:"
                                          description=""/>
                        <span> {this.props.date.toString().split("-")[0]} 年 {this.props.date.toString().split("-")[1]} 月 {this.props.date.toString().split("-")[2]} 日
                             {new Date().getHours()} 時 {new Date().getMinutes()} 分</span>
                        {/*<br/>*/}
                        {/*&nbsp;&nbsp;{this.props.date}*/}
                    </div>
                </div>
            </div>

        )
    }
}

export default InquiryReplyTitleBar;


// WEBPACK FOOTER //
// ./src/components/Admin/InquiryReply/InquiryReplyTitleBar.js